import { each, endsWith, get, has, isArray, isEmpty, isPlainObject, mapValues, result, toString } from 'lodash'
// import faker from 'faker'

export default
{
	data()
	{
		return {
			referenceNumber: null,
			isSubmitting:    false,
		}
	},

	computed:
	{
		hasReferenceNumber()
		{
			return !!this.referenceNumber
		},
	},

	methods:
	{
		prepareModel(mapping, source, destination)
		{
			destination = destination || this.model

			each
			(
				mapping,
				(sourceKey, destinationKey) => this.$set(destination, destinationKey, result(source, sourceKey))
			)
		},

		referenceNumberHandler(response)
		{
			this.referenceNumber = result(response.data, 'reference_number')
		},

		bindReset(value, key='model')
		{
			return () =>
			{
				this[key] = { ...value }

				this.reset()
			}
		},

		reset()
		{
			this.isSubmitting = false
		},

		resetSubmitting()
		{
			this.isSubmitting = false
		},

		resetQuestionnaire(questionnaireType)
		{
			this.reset()
			this.resetReferenceNumber()

			this.model  = (questionnaireType === 'sdwan' || questionnaireType === 'credit') ? this.model : this.resetObject(this.model)

			this.model.order_id  = ''
			this.$router.push({ name: 'questionnaires.' + questionnaireType })
		},

		resetReferenceNumber()
		{
			this.referenceNumber = null
		},

		resetValidation(response)
		{
			this.isSubmitting = false
		},

		resetObject(object)
		{
			return mapValues
			(
				object,
				(value, key) =>
				{
					if ( isArray(value) )
					{
						let entry = {}

						each
						(
							value[0],
							(value, key) =>
							{
								entry[key] = null
							}
						)

						return [ entry ]
					}

					return null
				}
			)
		},

		/*
		runGeneration(model, mapping, callbacks)
		{
			each
			(
				model,
				(value, key) =>
				{
					if ( has(callbacks, key) )
					{
						value = get(callbacks, key)(value, key, faker)

						this.$set(model, key, value)
					}
					else if ( isArray(value) || isPlainObject(value) )
					{
						this.runGeneration(value, mapping, callbacks)
					}
					else
					{
						each
						(
							mapping,
							(array, command) =>
							{
								each
								(
									array,
									entry =>
									{
										if ( entry && toString(key).indexOf(entry) > -1 )
										{
											value = get(faker, command)()

											if ( command.indexOf('boolean') > -1 )
											{
												value = ( value ) ? 'yes' : 'no'
											}

											this.$set(model, key, value)
										}
									}
								)
							}
						)
					}
				}
			)
		},
		*/
	},
}